export const MOSCOW_ID = 1;
export const SPB_ID = 2;
export const MOSCOW_REGION_ID = 4593;
export const SPB_REGION_ID = 4588;
export const REGIONS_WITH_UNDERGROUND = [MOSCOW_ID, MOSCOW_REGION_ID, 2, 4743, 4777, 4885, 4897, 4966];
